import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import usePageMeta from '../utils/usePageMeta';
import logo from '../assets/img/logo2.png';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const { register, loading, error, clearError } = useAuth();
  const navigate = useNavigate();

  usePageMeta({
    title: 'Create Account',
    description: 'Create a free Doritostats account to unlock advanced fantasy football analytics for your ESPN leagues.',
    canonical: '/register',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();
    const result = await register(email, password, passwordConfirm);
    if (result.success) {
      navigate('/dashboard');
    }
  };

  return (
    <main className="min-h-screen bg-bg flex flex-col items-center justify-center px-4">
      {/* Logo */}
      <Link to="/" className="mb-8">
        <img src={logo} alt="Dorito Stats home" className="h-14" />
      </Link>

      <div className="w-full max-w-sm bg-ds-white border border-border-card rounded-card shadow-card p-8">
        <h1 className="font-display text-2xl font-black text-ds-text mb-6">
          Create account
        </h1>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block text-xs font-bold text-text-muted uppercase tracking-wider mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="w-full border border-border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-green transition-colors"
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-text-muted uppercase tracking-wider mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full border border-border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-green transition-colors"
              placeholder="••••••••"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-text-muted uppercase tracking-wider mb-1">
              Confirm password
            </label>
            <input
              type="password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              required
              className="w-full border border-border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-green transition-colors"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p className="text-coral text-sm font-semibold">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-mustard text-forest font-extrabold text-sm py-2.5 rounded-lg shadow-mustard hover:bg-yellow-500 transition-colors disabled:opacity-60 mt-1"
          >
            {loading ? 'Creating account…' : 'Create account'}
          </button>
        </form>

        <p className="mt-4 text-xs text-text-muted">
          By creating an account you agree to the{' '}
          <Link to="/privacy" className="text-green font-semibold hover:text-mustard transition-colors">
            Privacy Policy
          </Link>
          .
        </p>
        <p className="mt-4 text-sm text-text-muted">
          Already have an account?{' '}
          <Link to="/login" className="text-green font-semibold hover:text-mustard transition-colors">
            Sign in
          </Link>
        </p>
      </div>
    </main>
  );
};

export default RegisterPage;
